module.exports = __webpack_public_path__ + "assets/img/03c2-lk.svg";